// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@adl/XDL/Utilities";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface BrandDetailsItemSharedStyles {
    title?: TypographyProps;
    container?: InjectableCss;
    categoryContainer?: GridContainerProps;
    itemRow?: GridItemProps;
    categoryItemColumn?: GridItemProps;
    innerContainer?: ClickablePresentationProps;
    categoryImageItem?: GridItemProps;
    categoryImage?: LazyImageProps;
    categoryNameLink?: LinkProps;
}

const brandDetailsItemSharedStyles: BrandDetailsItemSharedStyles = {
    title: {
        as: "h4",
        variant: "headerSecondary",
        transform: "inherit",
        size: 28,
        css: css`
            line-height: 34px;
            margin-bottom: 20px;
        `,
    },
    container: {
        css: css`
            border-top: 1px solid ${color("common.ui5")};
            padding-top: 15px;
            margin-bottom: 20px;
        `,
    },
    categoryContainer: {
        gap: 10,
    },
    itemRow: {
        width: [12, 6, 4, 3, 2],
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `,
    },
    innerContainer: {
        css: css`
            background: ${color("common.white")};
            padding: 10px;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    categoryImage: {
        width: "168px",
        height: "168px",
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    categoryImageItem: {
        width: 12,
        align: "middle",
        css: css`
            width: 100%;
            height: 168px;
            justify-content: center;
        `,
    },
    categoryNameLink: {
        color: "text.main",
        typographyProps: {
            size: 16,
            weight: "bold",
            css: css`
                overflow-wrap: break-word;
                word-wrap: break-word;
                line-height: 20px;
            `,
        },
        css: css`
            align-self: center;
            text-align: center;
            margin-top: 10px;
            margin-bottom: 5px;
        `,
    },
};

export default brandDetailsItemSharedStyles;
